module.exports = __webpack_public_path__ + "static/media/Convinence.ae2714bf.png";